import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=3fd01873&scoped=true"
import script from "./EmployeeCard.vue?vue&type=script&lang=ts"
export * from "./EmployeeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd01873",
  null
  
)

export default component.exports